module.exports = __webpack_public_path__ + "static/modal-success-bg-1e0b4ac5ecb88d114aa22a72324a82e1.png";